import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import { toast } from "react-toastify";
import Select from "react-select";
import Modal from "react-modal";
import {
  fieldsInitial,
  farmerTypeOptions,
  switchEmpFar,
  switchType,
  switchEmplabelFar,
} from "./../model-gatepass";

const GatePassInPrint = (props) => {
  const [data, setData] = useState([]);
  const { sendRequest: getDataList } = useHttp();

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/gatePass/?gatepassType=In&orgId=${localStorage.getItem(
          "orgId"
        )}&&warehouseId=${localStorage.getItem("warehouseId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  // window.addEventListener("load", window.print())

  return (
    <>
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-body">
                  <div className="invoice p-3 mb-3">
                    <div className="row">
                      <div className="col-md-4"></div>
                      <div className="col-md-4 text-center">
                        <h2> Company Name </h2>
                        <h4> Getpass </h4>
                      </div>
                      <div className="col-md-4"></div>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <h4>
                          <i className="fas fa-globe"></i> AdminLTE, Inc.
                          <small className="float-right">Date: 2/10/2014</small>
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default GatePassInPrint;
